import React, { Component } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import {
  format_date,
  Pagination,
  GET,
  loading,
  Navbar,
  saveAs,
  MonthPicker,
  Select,
  alert,
} from "../../components/CustomComponent.js";
import JSZip from "jszip";
import {
  report_invoice,
  report_tax_withholding,
} from "../../components/Report.js";

import { GATEWAY_LOGO, gateway_logo_background } from "../../components/GatewayLogo.js";
export default class Settlements extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data_broker: [],
      data: [],
      loaded: false,
      count: 0,

      filter_year_month: format_date(new Date(), "yyyy-mm", "en"),
      filter_broker: "",
      filter_type: "deposit",
    };
  }

  async componentDidMount() {
    loading(false);
    this.GetBroker();
  }
  GetBroker = async () => {
    let data_broker = [];
    let result_broker = await GET("v1/admin/brokers/options", {
      page_size: 1000000,
      page: 0,
      data_search: "",
    });
    if (result_broker?.status) {
      data_broker = result_broker.data.map((e) => ({
        value: e.uid,
        label: e.name_en,
      }));
    }
    this.setState({ data_broker });
  };
  Get = async (page) => {
    const { filter_year_month, filter_broker, filter_type } = this.state;
    if (
      filter_year_month === "" ||
      filter_broker === "" ||
      filter_type === ""
    ) {
      return alert("", "warning", "Warning", "Please select all filter");
    }
    let data = [];
    let count = 0;
    loading(true);
    let result = await GET("v1/admin/invoices", {
      year_month: filter_year_month,
      broker_id: filter_broker,
      type: filter_type,
    });
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    this.setState({ data, loaded: true, count });

    loading(false);
  };
  DownloadAllBroker = async () => {
  loading(true);

  const { filter_year_month } = this.state;
    let data = [];
    loading(true);
    let result = await GET("v1/admin/invoices", {
      year_month: filter_year_month,
      broker_id: "",
      type: "",
    });
    if (result?.status) {
      data = result.data;
    }
    console.log("data:", data)

  const zip = new JSZip();

  const tasks = [];

  for (const item of data) {
    for (const e of item.items) {

      const brokerName = e.broker?.name_en?.toUpperCase() || "-";
      const gateway = e.gateway?.toUpperCase() || "-";

      // 📄 Tax
      tasks.push(async () => {
        const base64 = await report_tax_withholding(item.date, e);
        return {
          path: `${e.broker?.name_en}/tax/${format_date(item.date,"dd-mm-yy","en")}_${brokerName}_${gateway}_TAX.pdf`,
          data: base64
        };
      });

      // 📄 Invoice
      tasks.push(async () => {
        const base64 = await report_invoice(item.date, e);
        return {
          path: `${e.broker?.name_en}/invoice/${format_date(item.date,"dd-mm-yy","en")}_${brokerName}_${gateway}_INVOICE.pdf`,
          data: base64
        };
      });
    }
  }

  // ✅ runner จำกัด concurrency
  const runWithLimit = async (tasks, limit = 5) => {
    const results = [];
    const executing = [];

    for (const task of tasks) {
      const p = task().then(res => {
        executing.splice(executing.indexOf(p), 1);
        return res;
      });

      results.push(p);
      executing.push(p);

      if (executing.length >= limit) {
        await Promise.race(executing);
      }
    }

    return Promise.all(results);
  };

  // 🔥 รันทีละ 5
  const results = await runWithLimit(tasks, 5);

  // 📦 ใส่ zip
  results.forEach(file => {
    zip.file(file.path, file.data, { base64: true });
  });

  // 📦 generate zip
  const content = await zip.generateAsync({ type: "blob" });

  // 💾 download
  saveAs(
    content,
    `${format_date(filter_year_month+"-01", "mm-yy", "en")}_ALL_BROKER.zip`
  );

  loading(false);
};
  DownloadAll = async () => {
  loading(true);

  const { filter_year_month, data, data_broker, filter_broker } = this.state;
  const zip = new JSZip();

  const tasks = [];

  for (const item of data) {
    for (const e of item.items) {

      const brokerName = e.broker?.name_en?.toUpperCase() || "-";
      const gateway = e.gateway?.toUpperCase() || "-";

      // 📄 Tax
      tasks.push(async () => {
        const base64 = await report_tax_withholding(item.date, e);
        return {
          path: `tax/${format_date(item.date,"dd-mm-yy","en")}_${brokerName}_${gateway}_TAX.pdf`,
          data: base64
        };
      });

      // 📄 Invoice
      tasks.push(async () => {
        const base64 = await report_invoice(item.date, e);
        return {
          path: `invoice/${format_date(item.date,"dd-mm-yy","en")}_${brokerName}_${gateway}_INVOICE.pdf`,
          data: base64
        };
      });
    }
  }

  // ✅ runner จำกัด concurrency
  const runWithLimit = async (tasks, limit = 5) => {
    const results = [];
    const executing = [];

    for (const task of tasks) {
      const p = task().then(res => {
        executing.splice(executing.indexOf(p), 1);
        return res;
      });

      results.push(p);
      executing.push(p);

      if (executing.length >= limit) {
        await Promise.race(executing);
      }
    }

    return Promise.all(results);
  };

  // 🔥 รันทีละ 5
  const results = await runWithLimit(tasks, 5);

  // 📦 ใส่ zip
  results.forEach(file => {
    zip.file(file.path, file.data, { base64: true });
  });

  // 📦 generate zip
  const content = await zip.generateAsync({ type: "blob" });

  // 💾 download
  saveAs(
    content,
    `${format_date(filter_year_month+"-01", "mm-yy", "en")}_${data_broker?.find(e=>e.value === filter_broker)?.label || "-"}.zip`
  );

  loading(false);
};
  // -------------------------------------------------------------------------
  // Render helpers (presentation only — Get / DownloadAll* / report calls are
  // unchanged)
  // -------------------------------------------------------------------------
  downloadPdf = async (kind, item, e) => {
    let base64 =
      kind === "tax"
        ? await report_tax_withholding(item.date, e)
        : await report_invoice(item.date, e);
    const link = document.createElement("a");
    link.href = `data:application/pdf;base64,${base64}`;
    link.download = `${format_date(item.date, "dd-mm-yy", "en")}_${
      e.broker?.name_en?.toUpperCase() || "-"
    }_${e.gateway?.toUpperCase() || "-"}_${kind === "tax" ? "TAX" : "INVOICE"}.pdf`;
    link.click();
  };
  render() {
    const {
      data,
      loaded,
      count,
      data_broker,
      filter_year_month,
      filter_broker,
      filter_type,
    } = this.state;
    const groups = Array.isArray(data) ? data : [];
    const rows = groups.flatMap((item) =>
      (item.items || []).map((e) => ({ item, e }))
    );
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ];
    const selectedDate = filter_year_month ? new Date(filter_year_month) : null;
    const heroMonth =
      selectedDate && !isNaN(selectedDate)
        ? monthNames[selectedDate.getMonth()].slice(0, 3).toUpperCase()
        : "—";
    const heroYear =
      selectedDate && !isNaN(selectedDate) ? selectedDate.getFullYear() : "";
    const selectedBrokerLabel = data_broker?.find(
      (b) => b.value === filter_broker
    )?.label;
    const typeLabel = filter_type === "withdrawals" ? "Withdrawal" : "Deposit";
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          {/* ===== Hero ===== */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Invoice Report</div>
                <div className="ar-title">Invoice Reports</div>
                <div className="ar-subtitle">
                  Invoice and withholding tax documents per broker and gateway
                </div>
              </div>
              <div className="ar-hero-actions">
                <button
                  className="ar-btn-gold"
                  title="Download every broker's invoices for this month as a zip"
                  onClick={() => {
                    this.DownloadAllBroker();
                  }}
                >
                  <span className="icon me-2">{""}</span>Download All Broker
                </button>
                <div className="text-end ms-2">
                  <div className="ar-year">
                    {heroMonth}
                    <span className="ar-year-small"> {heroYear}</span>
                  </div>
                  <div className="ar-year-caption">
                    <span>{typeLabel}</span>
                    {selectedBrokerLabel && (
                      <span className="ar-caption-chip ms-2">{selectedBrokerLabel}</span>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="ar-toolbar ar-filter mt-3">
<div className="ar-filter-head">
<span className="ar-toolbar-label"><span className="icon me-2">{""}</span>Filter</span>
</div>
<div className="ar-filter-row">
<div className="ar-filter-field">
<span className="ar-filter-label">Month</span>
<MonthPicker
                    className="form-control"
                    placeholder="Month..."
                    onChange={(e) => {
                      this.setState({ filter_year_month: e });
                    }}
                    value={filter_year_month}
                  />
</div>
<div className="ar-filter-field">
<span className="ar-filter-label">Broker</span>
<Select
                    className="form-control"
                    placeholder="Select broker"
                    options={data_broker}
                    onChange={(e) => {
                      this.setState({
                        filter_broker: e,
                      });
                    }}
                    value={filter_broker}
                  />
</div>
<div className="ar-filter-field">
<span className="ar-filter-label">Type</span>
<Select
                    className="form-control"
                    placeholder="Type"
                    options={[
                      { value: "deposit", label: "Deposit" },
                      { value: "withdrawals", label: "Withdrawal" },
                    ]}
                    value={filter_type}
                    onChange={(v) => {
                      this.setState({ filter_type: v });
                    }}
                  />
</div>
<div className="ar-toolbar-actions">
                <button className="ar-btn-gold" onClick={() => this.Get(1)}>
                  <span className="icon me-2">{""}</span>Search
                </button>
                <button
                  className="ar-btn-ghost"
                  onClick={() =>
                    this.setState(
                      {
                        filter_year_month: format_date(new Date(), "yyyy-mm", "en"),
                        filter_broker: "",
                        filter_type: "deposit",
                      },
                      () => this.Get(1)
                    )
                  }
                >
                  Reset
                </button>
              </div>
</div>
</div>
          </div>

          {/* ===== Table ===== */}
          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{""}</span>
                  Invoices
                </div>
                <div className="ar-table-caption">
                  {heroMonth} {heroYear} · {typeLabel} ·{" "}
                  {selectedBrokerLabel ? selectedBrokerLabel : "No broker selected"} ·{" "}
                  {rows.length} document{rows.length === 1 ? "" : "s"}
                </div>
              </div>
              {rows.length > 0 && (
                <button
                  className="pu-open-btn"
                  title="Download all documents in this list as a zip"
                  onClick={() => {
                    this.DownloadAll();
                  }}
                >
                  <span className="pu-open-label">Download All</span>
                  <span className="icon">{""}</span>
                </button>
              )}
            </div>
            <div className="table-responsive">
              <table className="table table-hover text-nowrap ar-table pu-table">
                <thead>
                  <tr>
                    <td className="text-nowrap wpx-140">Date</td>
                    <td className="text-nowrap">Broker</td>
                    <td className="text-nowrap">Gateway</td>
                    <td className="text-nowrap">Invoice No.</td>
                    <td className="text-nowrap text-center wpx-140">Actions</td>
                  </tr>
                </thead>
                <tbody>
                  {rows.map(({ item, e }, index) => {
                    const d = new Date(item.date);
                    const day = isNaN(d) ? "" : String(d.getDate()).padStart(2, "0");
                    const broker = e.broker?.name_en || "-";
                    return (
                      <tr key={e.invoice_number || `${item.date}-${e.gateway}-${index}`}>
                        <td data-label="Date">
                          <div className="ar-month-badge">
                            <span>{day}</span>
                            {format_date(item.date, "dd/mm/yyyy", "en")}
                          </div>
                        </td>
                        <td data-label="Broker">
                          <div className="pu-user">
                            <div className="pu-avatar">
                              {broker.trim().charAt(0).toUpperCase()}
                            </div>
                            <div className="min-w-0">
                              <div className="pu-name text-truncate" title={broker}>
                                {broker}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td data-label="Gateway">
                          <div className="pu-gateway">
                            <img
                              src={GATEWAY_LOGO[e.gateway]}
                              alt={e.gateway}
                              width={28}
                              height={28}
                              className="rounded-circle pu-gateway-img"
                              style={{
                                objectFit: "cover",
                                background: gateway_logo_background(e.gateway),
                              }}
                            />
                            <div className="pu-gateway-name">
                              <span className="text-capitalize">{e.gateway || "-"}</span>
                            </div>
                          </div>
                        </td>
                        <td data-label="Invoice No.">
                          <span className="pu-code">{e.invoice_number || "-"}</span>
                        </td>
                        <td data-label="Actions" className="text-center td-actions align-middle">
                          <Dropdown align="end">
                            <Dropdown.Toggle className="pu-action-toggle" id={`invoices-actions-${index}`}>Action</Dropdown.Toggle>
                            <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                              <Dropdown.Item
                                data-testid="btn-report-withholding-tax"
                                className="pu-action-item"
                                onClick={() => this.downloadPdf("tax", item, e)}
                              >
                                <span className="icon">{""}</span>Withholding Tax PDF
                              </Dropdown.Item>
                              <Dropdown.Item
                                data-testid="btn-report-invoice"
                                className="pu-action-item"
                                onClick={() => this.downloadPdf("invoice", item, e)}
                              >
                                <span className="icon">{""}</span>Invoice PDF
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    );
                  })}
                  {loaded && rows.length === 0 && (
                    <tr>
                      <td colSpan={5} className="text-center py-5">
                        <div className="ar-empty">
                          <span className="icon d-block mb-2">{""}</span>
                          No invoice for {heroMonth} {heroYear} · {typeLabel}
                          {selectedBrokerLabel ? ` · ${selectedBrokerLabel}` : ""}
                        </div>
                      </td>
                    </tr>
                  )}
                  {!loaded && (
                    <tr>
                      <td colSpan={5} className="text-center py-5">
                        <div className="ar-empty">
                          <span className="icon d-block mb-2">{""}</span>
                          Select a month, broker and type, then press Search
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-3">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / 10) || 1}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div>
        </div>
      </div>
    );
  }
}
